module.exports = __webpack_public_path__ + "img/collab-logo@2x.8b117921.png";